import { Injectable } from '@angular/core';
import { TransactionSummaryService } from './transaction-summary.service';
import { ITransactionSummary } from './itransaction-summary.interface';
import { TitleRegistrationTransactionSummaryService } from './title-registration-transaction-summary.service';

@Injectable()
/**
 * Factory service for getting source system implementation of transaction summaries
 */
export class TransactionSummaryFactory {
    private services: TransactionSummaryService[];

    constructor(private titleRegistrationTransactionSummaryService: TitleRegistrationTransactionSummaryService) {
        this.services = [];
        this.services.push(titleRegistrationTransactionSummaryService);
    }

    /**
     * Get the transaction summary for the specified source system
     */
    public create(sourceSystemTypeId: number): ITransactionSummary {
        return this.services.find(s => s.sourceSystemType.id == sourceSystemTypeId);
    }
}
